module.exports = __webpack_public_path__ + "static/media/howItWorks_3.6eaaaa46.svg";